
export default  [
    {
        class: 'col-xs-12 col-sm-12 col-md-6 col-lg-6 col-xl-6',
        type: 'date-range',
        field: 'agendamento_at',
        label: 'Data do Agendamento',
        clearable: true,
        rules: ['']
    },
    {
        class: 'col-xs-12 col-sm-12 col-md-6 col-lg-6 col-xl-6',
        type: 'date-range',
        field: 'created_at',
        label: 'Data de Cadastro',
        clearable: true,
        rules: ['']
    },
    {
        class: 'col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12',
        type: 'select-custom',
        field: 'id_empresa',
        label: 'Empresa',
        clearable:true,
        option: {
            label: 'nome',
            value: 'id'
        },
        rules: ['']
    },
    {
        class: 'col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12',
        type: 'select-custom',
        field: 'id_funcionario',
        label: 'Funcionário',
        clearable: true,
        option: {
            label: 'nome',
            value: 'id'
        },
        rules: ['']
    },
    {
        class: 'col-xs-12 col-sm-12 col-md-6 col-lg-6 col-xl-6',
        type: 'select-tipo',
        field: 'id_tipo_aso',
        label: 'Tipo de ASO',
        clearable: true,
        multiple: true,
        tipo: 46,
        rules: ['']
    },
    {
        class: 'col-xs-12 col-sm-12 col-md-6 col-lg-6 col-xl-6',
        type: 'select-tipo',
        field: 'id_tipo_status',
        label: 'Status',
        clearable: true,
        multiple:true,
        tipo: 53,
        rules: ['']
    },
    {
        class: 'col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12',
        type: 'boolean',
        field: 'deleted',
        label: 'Mostrar Consultas Excluídas',
        rules: ['']
    },
];




// WEBPACK FOOTER //
// ./src/components/apps/credenciada/consulta/_form/consulta-filtro.js